
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import AppAccordion from '~/components/AppAccordion/AppAccordion.vue'
import AppAccordionItem from '~/components/AppAccordion/AppAccordionItem.vue'
import { FAQItem } from '~/composables/seo.composable'

@Component({
  components: {
    AppAccordion,
    AppAccordionItem,
  },
})
export default class FaqSection extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  title!: string

  @Prop({
    type: Array,
    required: true,
  })
  items!: FAQItem[]

  private showAll = false

  get displayedItems (): FAQItem[] {
    if (this.showAll || this.items.length <= 10) {
      return this.items
    }
    return this.items.slice(0, 10)
  }

  get leftColumnItems (): FAQItem[] {
    const half = Math.ceil(this.displayedItems.length / 2)
    return this.displayedItems.slice(0, half)
  }

  get rightColumnItems (): FAQItem[] {
    const half = Math.ceil(this.displayedItems.length / 2)
    return this.displayedItems.slice(half)
  }

  toggleQuestions (): void {
    this.showAll = !this.showAll
    this.$emit('toggle-questions', this.showAll)
  }
}
